module.exports = __webpack_public_path__ + "CreativeDirection6.png?70aad5c18639f94abcf0fffb9343d313";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection6.png
// module id = 54
// module chunks = 0